// extracted by mini-css-extract-plugin
export default {"label":"yEivnn_mLabN_9Fi7w8A"};